import Section from "@/components/site/Section";
import { Reveal } from "@/components/site/Reveal";
import { Overline } from "@/components/site/primitives";

const SECTORS = [
  "EV adoption", "Highway travel", "Hospitality", "Convenience retail",
  "Food & beverage", "Digital connectivity", "Transportation infrastructure",
];

export default function AboutSection() {
  return (
    <Section id="about" data-testid="about">
      <div className="grid gap-14 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-6">
          <Overline>About RestPower</Overline>
          <h2 className="mt-5 font-display text-4xl font-light uppercase leading-[0.95] tracking-tight md:text-5xl">
            A better way to stop.
          </h2>
          <div className="mt-6 space-y-5 text-base leading-relaxed text-white/55 md:text-lg">
            <p>
              Roadside infrastructure has historically been designed around vehicles first. RestPower's
              vision is to design the stop around both the vehicle <span className="text-white">and</span> the
              traveler.
            </p>
            <p>
              Our mission is simple: transform charging time into useful, comfortable, and enjoyable time.
              This isn't an EV charging station with amenities — it's a roadside destination that happens to
              charge your car.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.08} className="lg:col-span-6">
          <div className="rounded-3xl border border-white/10 bg-rp-card p-8 md:p-10">
            <Overline>Business & Investor Overview</Overline>
            <h3 className="mt-5 font-display text-2xl font-light uppercase leading-tight tracking-tight md:text-3xl">
              Building infrastructure around the time between destinations.
            </h3>
            <p className="mt-5 text-sm leading-relaxed text-white/55">
              RestPower sits at the intersection of several converging sectors — an opportunity to improve
              the time travelers already spend waiting.
            </p>
            <div className="mt-6 flex flex-wrap gap-2.5">
              {SECTORS.map((s) => (
                <span key={s} className="rounded-full border border-white/12 bg-rp-bg px-3.5 py-2 font-mono text-[11px] uppercase tracking-[0.1em] text-white/60">
                  {s}
                </span>
              ))}
            </div>
            <a
              href="#partners"
              data-testid="about-investor-cta"
              className="mt-8 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.14em] text-rp-accent transition-colors hover:text-white"
            >
              Business & Partnership Inquiries →
            </a>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
